export const AtlasMarkInverse = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.007 9.47089V6.58789C14.019 6.58789 5.89795 14.7089 5.89795 24.6959C5.89795 25.7269 5.99595 26.7299 6.14895 27.7189C6.14895 27.7609 6.14895 27.8169 6.16295 27.8579C7.66695 36.3409 15.078 42.8049 23.993 42.8049V39.9219C16.443 39.9219 10.1609 34.4059 8.97695 27.1899C8.87895 26.4659 9.08795 25.7269 9.56195 25.1419C10.3139 24.2229 11.6649 23.7349 13.4619 23.7349C14.4089 23.7349 15.3009 23.8599 16.2339 24.1109V21.1579C15.3289 20.9629 14.4229 20.8649 13.4619 20.8649C11.4979 20.8649 10.0629 21.3109 9.03195 21.9099C10.3549 14.8339 16.568 9.47089 24.006 9.47089H24.007Z"
      fill="url(#paint0_linear_818_463)"
    />
    <path
      d="M26.946 25.4207C26.25 25.1147 25.469 24.7517 24.578 24.3617C24.063 24.1387 23.561 23.9157 23.088 23.7067C20.386 22.5087 18.31 21.5897 16.235 21.1577V24.1107C17.809 24.5287 19.522 25.2807 21.918 26.3397C22.392 26.5487 22.893 26.7717 23.422 26.9947C24.3 27.3847 25.08 27.7327 25.762 28.0397C28.283 29.1677 29.802 29.8507 31.724 30.2407L32.281 27.4127C30.679 27.0927 29.356 26.5077 26.946 25.4207Z"
      fill="url(#paint1_linear_818_463)"
    />
    <path
      d="M42.1019 24.3759V23.6659C41.5449 14.1519 33.6469 6.58789 24.0069 6.58789V9.47089C32.2949 9.47089 39.0509 16.1149 39.2179 24.3619C39.2039 24.9329 39.0369 25.6849 38.4379 26.3399C37.6579 27.1899 36.3069 27.6349 34.5239 27.6349C33.7579 27.6349 33.0199 27.5649 32.2669 27.4119L31.7099 30.2399C32.6429 30.4209 33.5629 30.5189 34.5239 30.5189C36.1119 30.5189 37.3659 30.2399 38.3269 29.8229C36.2239 35.7009 30.5819 39.9219 23.9929 39.9219V42.8049C33.9809 42.8049 42.1019 34.6839 42.1019 24.6959C42.1019 24.5849 42.1019 24.4869 42.1019 24.3759Z"
      fill="url(#paint2_linear_818_463)"
    />
    <path
      d="M24.0069 42.8046V39.9216C28.1439 39.9216 30.6099 35.7006 30.6099 28.6386C30.6099 21.5766 28.1029 15.6556 22.9629 10.1816L25.0659 8.20361C30.7349 14.2356 33.4929 20.9216 33.4929 28.6386C33.4929 37.3726 29.8569 42.8056 24.0069 42.8056V42.8046Z"
      fill="url(#paint3_linear_818_463)"
    />
    <path
      d="M24.007 42.8048C17.78 42.8048 14.214 37.7348 14.214 28.8888C14.214 18.5668 18.727 12.7998 22.948 8.2168L25.065 10.1668C20.148 15.5158 17.097 20.5028 17.097 28.8888C17.097 38.0128 20.858 39.9208 24.006 39.9208V42.8038L24.007 42.8048Z"
      fill="url(#paint4_linear_818_463)"
    />
    <path
      d="M16.2899 26.201C18.1517 26.201 19.6609 24.6917 19.6609 22.83C19.6609 20.9682 18.1517 19.459 16.2899 19.459C14.4282 19.459 12.9189 20.9682 12.9189 22.83C12.9189 24.6917 14.4282 26.201 16.2899 26.201Z"
      fill="white"
    />
    <path
      d="M31.877 32.0101C33.7387 32.0101 35.248 30.5008 35.248 28.6391C35.248 26.7773 33.7387 25.2681 31.877 25.2681C30.0152 25.2681 28.506 26.7773 28.506 28.6391C28.506 30.5008 30.0152 32.0101 31.877 32.0101Z"
      fill="white"
    />
    <path
      d="M24.007 11.9368C25.8687 11.9368 27.378 10.4276 27.378 8.56582C27.378 6.70407 25.8687 5.19482 24.007 5.19482C22.1452 5.19482 20.636 6.70407 20.636 8.56582C20.636 10.4276 22.1452 11.9368 24.007 11.9368Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_463"
        x1="19.736"
        y1="37.9869"
        x2="12.939"
        y2="7.70389"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.17" stopColor="white" stopOpacity="0.91" />
        <stop offset="0.5" stopColor="white" stopOpacity="0.74" />
        <stop offset="0.76" stopColor="white" stopOpacity="0.64" />
        <stop offset="0.92" stopColor="white" stopOpacity="0.6" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_818_463"
        x1="16.039"
        y1="22.5087"
        x2="30.624"
        y2="28.3597"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.18" stopColor="white" stopOpacity="0.91" />
        <stop offset="0.55" stopColor="white" stopOpacity="0.74" />
        <stop offset="0.83" stopColor="white" stopOpacity="0.64" />
        <stop offset="1" stopColor="white" stopOpacity="0.6" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_818_463"
        x1="34.0849"
        y1="5.38889"
        x2="31.2429"
        y2="34.8779"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.18" stopColor="white" stopOpacity="0.91" />
        <stop offset="0.55" stopColor="white" stopOpacity="0.74" />
        <stop offset="0.83" stopColor="white" stopOpacity="0.64" />
        <stop offset="1" stopColor="white" stopOpacity="0.6" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_818_463"
        x1="28.2279"
        y1="42.8046"
        x2="28.2279"
        y2="8.20361"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.1" stopColor="white" />
        <stop offset="0.27" stopColor="white" stopOpacity="0.91" />
        <stop offset="0.59" stopColor="white" stopOpacity="0.74" />
        <stop offset="0.85" stopColor="white" stopOpacity="0.64" />
        <stop offset="1" stopColor="white" stopOpacity="0.6" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_818_463"
        x1="18.854"
        y1="7.6458"
        x2="20.916"
        y2="40.1028"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.03" stopColor="white" />
        <stop offset="0.1" stopColor="white" stopOpacity="0.9" />
        <stop offset="0.29" stopColor="white" stopOpacity="0.68" />
        <stop offset="0.38" stopColor="white" stopOpacity="0.6" />
        <stop offset="0.59" stopColor="white" stopOpacity="0.6" />
        <stop offset="0.65" stopColor="white" stopOpacity="0.65" />
        <stop offset="0.76" stopColor="white" stopOpacity="0.77" />
        <stop offset="0.91" stopColor="white" stopOpacity="0.96" />
        <stop offset="0.94" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);
